import React from 'react'
import { connect } from 'react-redux'
import { compose, setDisplayName, withHandlers } from 'recompose'
import { bindActionCreators } from 'redux'
import { downloadInvoice } from 'store/reducers/invoices'

import {
  DownloadIcon,
  StyledLink
} from './Download.style'

const behavior = compose(
  setDisplayName('behavior'),
  connect(({ invoices }) => ({
    invoices
  }),
  dispatch => ({
    downloadInvoiceAction: bindActionCreators(downloadInvoice, dispatch)
  })
  ),
  withHandlers({
    downloadInvoiceHandler: ({ downloadInvoiceAction, param }) => () => {
      downloadInvoiceAction(param)
    }
  })
)

const Download = ({ downloadInvoiceHandler }) => (
  <StyledLink
    onClick={downloadInvoiceHandler}
  >
    <DownloadIcon />{'Baixar'}
  </StyledLink>
)

export default behavior(Download)
